import { SaveButton } from "components/Buttons"
import React from "react"
import { connect } from "react-redux"
import { Col, Row } from "reactstrap"

const DeleteUserModal = ({
  hideDeleteUserModal,
  loading,
  handleDeleteUser,
}) => {
  return (
    <React.Fragment>
      <Row>
        <Col>
          <h5>Are you sure you want to delete this user?</h5>
          <p>
            The user will be removed from the system. <br />
            This action CAN NOT be reverted.
          </p>
          <p>Are you sure you want to continue?</p>
        </Col>
      </Row>

      <Row className="justify-content-end mt-3">
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Cancel"
            color="danger"
            onClick={hideDeleteUserModal}
          />
        </Col>
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Delete"
            onClick={handleDeleteUser}
            loading={loading}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  loading: state.people.deleteUserIsLoading,
})

export default connect(mapStateToProps)(DeleteUserModal)
